.wrapper {
	height: 100%;
	display: grid;
	place-content: center;
	gap: var(--size-3);
	padding: var(--size-3);
}

.title {
	display: flex;
	align-items: center;
	gap: var(--size-3);
}

.content {
	display: flex;
	flex-direction: column;
	gap: var(--size-3);
	max-width: 25rem;
	text-wrap: balance;
}

.content > p {
	margin: 0;
}

.message {
	max-width: max-content;
	text-wrap: initial;
	padding: var(--size-1) var(--size-3);
	color: var(--color-error-foreground);
	background-color: var(--color-error-background);
	border-radius: var(--radius-lg);
	user-select: text;
}
